import React, { Fragment, useContext, useEffect, useState } from 'react';
import { NavLink, useNavigate, useOutletContext } from 'react-router-dom'
import { useAxios } from '../../../hooks/useAxios';
import { nanoid } from 'nanoid';
import dayjs from 'dayjs'
import { ArrowsCollapse, ArrowsExpand, BoxArrowInUpRight, ArrowDownUp } from 'react-bootstrap-icons'

import { UserContext } from '../../../context/UserContext';

// import Modal from 'react-bootstrap/Modal';
// import Offcanvas from 'react-bootstrap/Offcanvas';
// import LibraryEdit from './components/LibraryEdit';
// import Category from './components/Category';
// import BulkEdit from './components/BulkEdit';
// import TypeEdit from './components/TypeEdit';

import { emptyObj } from '../../../utils/functions';

const View = (props) => {
  const navigate = useNavigate();
  const { parentType, parentId, parentAppId, library, project, orders, setOrders, schema, setLibraries, types, setTypes } = props;
  const { userDetails, setProjects, schemas, libraries } = useContext(UserContext);
  const { serverCall } = useAxios();

  const [bulkSchema, setBulkSchema] = useState([]);
  const [editSchema, setEditSchema] = useState([]);
  const [activeType, setActiveType] = useState({});
  const [selected, setSelected] = useState([]);

  // modal + offcanvas controls
  const [show, setShow] = useState(false);
  const handleClose = () => setShow();
  const closePanel = () => setActiveType({});

  useEffect(() => {
    let found = schemas.find(x => x.name === 'type-edit');
    if(found) setEditSchema(found.schema);

    found = schemas.find(x => x.name === 'type-bulk-edit');
    if(found) setBulkSchema(found.schema);
  }, [schemas])

  const fromChild = (data) => {
    const { type, value } = data;
    console.log(data);
  }

  return (
    <Fragment>
      <div className="row h-100 overflow-hidden">
        <div className="col-sm-9 h-100 overflow-scroll">
        <h5>Orders</h5>

        {(parentType==='project' && libraries.length > 0) && (
            <Fragment>
              <hr />
                <div className="mt-2">
                  { libraries.filter(x => !x.type && project.linked?.includes(x.id)).map(obj => (
                    <div key={obj.appId}>
                      <h4>{obj.name}</h4>
                    
                    </div>
                ))}
              </div>
          </Fragment>
        )}
        </div>
        <div className="col-sm-3 h-100 overflow-scroll">
          <h5>Actions</h5>

        </div>
      </div>

      {/* <Modal size="md" show={show} onHide={handleClose} centered scrollable>
        <BulkEdit userDetails={userDetails} schema={bulkSchema} selected={selected} setTypes={setTypes} handleClose={handleClose} toParent={fromChild} />
      </Modal>

      <Offcanvas show={!emptyObj(activeType)} style={{width:500}} onHide={closePanel} placement="end" scroll={true} keyboard={false} backdrop={false} className="shadow">
        <TypeEdit userDetails={userDetails} obj={activeType} schema={editSchema} setTypes={setTypes} handleClose={closePanel} toParent={fromChild} />
      </Offcanvas> */}
    </Fragment>
  )
}

export const OrdersOutlet = (props) => {
  const { parentType } = props;
  const { order, setLibraries, project, types, setTypes } = useOutletContext();

  if(emptyObj(order) && emptyObj(project))
    return <div>Error.</div>;
  if(parentType==='global')
    return <View parentType="global" order={order} parentId={order.id} parentAppId={order.appId} schema={order.schema} status={order.status} setLibraries={setLibraries} types={types} setTypes={setTypes} />
  else
    return <View parentType="project" project={project} parentId={project.id} parentAppId={project.appId} schema={project.order} types={types} setTypes={setTypes} />
}
